// extracted by mini-css-extract-plugin
export default {"quantity-numeric-input":"configurator-web-quantity-numeric-input","selected":"configurator-web-selected","invalid":"configurator-web-invalid"};